import { Injectable } from '@angular/core';

// other services
import { HttpClient } from '@angular/common/http';

// rxjs
import { Observable } from 'rxjs';

// models
import { Feed } from "../models/feed";

// configuration
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class FeedService {
    /**
     * constructor
     *
     * @param jwtHttp
     */
    constructor(
        private http: HttpClient,
    ) { }

    /**
     * set feed as visited
     *
     * @param {Feed} feed
     * @return {Observable<any>}
     */
    public visited(feed: Feed): Observable<any> {
        return this.http.get(environment.api + '/feed/visited/' + feed.id);
    }

    /**
     * @param {Feed} feed
     * @return {Observable<any>}
     */
    public decline(feed: Feed): Observable<any> {
        return this.http.get(environment.api + '/feed/decline/' + feed.id);
    }

    /**
     * @param {Feed} feed
     * @return {Observable<any>}
     */
    public accept(feed: Feed): Observable<any> {
        return this.http.get(environment.api + '/feed/accept/' + feed.id);
    }

    /**
     * @param {Feed} feed
     * @return {Observable<any>}
     */
    public postpone(feed: Feed): Observable<any> {
        return this.http.get(environment.api + '/feed/postpone/' + feed.id);
    }


}
